import SpecialsPage from 'src/dispensary/specials';
import { getDispensaryServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import { withLayout } from 'src/components/layouts/with-layout';

export const getServerSideProps = getDispensaryServerSideProps;

export default withLayout(SpecialsPage, CoreMenuLayout);
